// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__NNJ4J","range":"MonthRangeSwitch_range__3Ak5t","disabled":"MonthRangeSwitch_disabled__gc6eF"};